<script setup lang="ts">
import ActionButton from '@taler/ui/ActionButton.vue'
import StatusTag from '@taler/ui/StatusTag.vue'

/** A failed region in place of its content; `retrying` keeps Try again busy without clearing anything. */
defineProps<{ title: string; body?: string | undefined; retryLabel: string; retrying?: boolean }>()
const emit = defineEmits<{ retry: [] }>()
</script>

<template>
  <div
    role="alert"
    class="flex flex-col items-center gap-[var(--space-inline)] rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] px-[var(--space-block)] py-[var(--space-section)] text-center"
  >
    <StatusTag tone="danger" size="md">{{ title }}</StatusTag>
    <p v-if="body" class="max-w-[42ch] text-[length:var(--text-step-3)] text-[color:var(--color-text-muted)]">
      {{ body }}
    </p>
    <div class="mt-[var(--space-inline)]">
      <ActionButton :loading="retrying" @click="emit('retry')">{{ retryLabel }}</ActionButton>
    </div>
  </div>
</template>
